<li [ngClass]="{ selected: item.checked === 'YES', closed: item.closed }">
  <a *ngIf="!(item.type === 'RECORD' || item.type === 'DATA')" class="toggle clickable" (click)="toggle()">
    <t-icon *ngIf="!item.closed" name="remove_circle_outline"></t-icon>
    <t-icon *ngIf="item.closed" name="add_circle_outline"></t-icon>
  </a>

  <a *ngIf="item.type === 'RECORD' || item.type === 'DATA'" class="toggle">
    <t-icon name="insert_drive_file"></t-icon>
  </a>

  <a class="text clickable" (click)="toggleChecked()">
    <span>{{ item.label }}</span>
  </a>

  <a class="action clickable " (click)="toggleChecked()">
    <t-icon name="check_box" *ngIf="item.checked === 'YES'"></t-icon>
    <t-icon name="check_box_outline_blank" *ngIf="item.checked === 'NO'"></t-icon>
    <t-icon name="indeterminate_check_box" *ngIf="item.checked === 'INDETERMINATE'"></t-icon>
    <t-icon class="disabled" name="check_box_outline_blank" *ngIf="item.checked === 'DISABLED'"></t-icon>
  </a>

  <ul>
    <ng-container *ngFor="let child of item.children">
      <t-select-tree-item [item]="child" [treeComponent]="treeComponent"></t-select-tree-item>
    </ng-container>
  </ul>
</li>
